export default __webpack_public_path__ + "static/media/Micro_Focus_logo.11ec9f82.svg";